'use client';

import { c as _c } from "react/compiler-runtime";
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import { updateDataLayer } from '@module/utils/gtm/datalayer-utils';
import { useEffect } from 'react';
import useGetLoginInfoQuery from './auth/useGetLoginInfoQuery';
import useChannelTabRedirection from './channel/useChannelTabRedirection';

/**
 * playInfo의 변화에 따라 dataLayer에 푸시
 */
function usePlayInfoDataLayerService() {
  const $ = _c(4);
  const playInfo = useFetchLivePlayMutationStore(_temp);
  let t0;
  if ($[0] !== playInfo) {
    t0 = () => {
      if (!playInfo?.media) {
        return;
      }
      if (playInfo.media.userId) {
        updateDataLayer("play_id_changed");
      }
    };
    $[0] = playInfo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = playInfo?.token;
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t0, t2);
  return null;
}

/**
 *
 * idx 생성/삭제 시점에 dataLayer에 푸시
 */
function _temp(st) {
  return st.data;
}
function useUserIDXCreatedDataLayerService() {
  const $ = _c(4);
  const {
    userInfo
  } = useGetLoginInfoQuery();
  let t0;
  if ($[0] !== userInfo) {
    t0 = () => {
      if (userInfo?.idx) {
        if (!window.gtmDump) {
          window.gtmDump = {
            user: null
          };
        }
        if (window.gtmDump.user?.id !== userInfo.idx) {
          window.gtmDump.user = {
            id: userInfo.idx
          };
        }
        updateDataLayer("user_idx_created", {
          user_idx: userInfo.idx
        });
      } else {
        if (window.gtmDump) {
          window.gtmDump.user = null;
        }
        updateDataLayer("user_idx_purged", {
          user_idx: null
        });
      }
    };
    $[0] = userInfo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = userInfo?.idx;
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t0, t2);
  return null;
}

/**
 * PC 소비자 사이트(pandatv-pc/fanza-pc) 전용 리스너 묶음: 채널탭 리다이렉트 + GTM dataLayer 푸시.
 * mobile/sales에서는 돌지 않는다 — 마운트 여부는 UserSessionListeners가 SettingConfig로 판단한다.
 * (Sentry 유저 컨텍스트·로그아웃 캐시 무효화 같은 전 앱 공통 로직은 UserSessionListeners가 소유)
 */
export default function UserInfoListeners() {
  useChannelTabRedirection();
  usePlayInfoDataLayerService();
  useUserIDXCreatedDataLayerService();
  return null;
}